var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { marked } from 'marked';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { css } from 'styled-components';
export const youtubeIdRegex = /^https:\/\/(?:www\.youtube\.com\/watch\?v=|youtu\.be\/)([^/&\s]+)/i;
export const withoutProps = (Component, ...excludeProps) => props => {
    const { children } = props, compProps = __rest(props, ["children"]);
    for (const prop of excludeProps) {
        delete compProps[prop];
    }
    return React.createElement(Component, Object.assign({}, compProps), children);
};
export function useScrollYPosition() {
    const [y, setY] = React.useState(0);
    useScrollPosition(({ currPos }) => {
        setY(currPos.y);
    }, []);
    return y;
}
export function formatText(str) {
    return marked.parseInline((str || '').trim().replace(/(\\n|\n)/g, '<br />'), {
        xhtml: true,
        smartypants: true,
    });
}
export function fixHref(val) {
    if (val === null || val === undefined) {
        return val;
    }
    let href = val
        .trim()
        .replace(/^((https|http):)?(\/\/)?artists\.spotify\.com/, '');
    if (href === '')
        href = '/';
    return href;
}
export const transformScaleUp = `transform: scale(1.05);`;
export function isContentfulImage(url) {
    return (url &&
        (url.includes('images.ctfassets.net') ||
            url.includes('images.contentful.com')));
}
export const isValidPath = (url) => {
    if (url) {
        const decoded = decodeURIComponent(url);
        return (!decoded.includes('\\') &&
            !decoded.match(/^\/\//) &&
            !decoded.match(/^.+:.+/));
    }
    return false;
};
export const getBurst = (color) => {
    return css `
    background-image: url("
      data:image/svg+xml,%3Csvg
      width='465'
      height='225'
      viewBox='0 0 465 224'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'%3E%3Cpath
      d='M1 223L332.118 2L250.776 207.016L353.662 123.272L336.101 184.082L465 106.069'
      stroke='%23${color.substring(1)}'/%3E%3C/svg%3E
    ");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right center;
  `;
};
export const mergeRefs = (...refs) => {
    const filteredRefs = refs.filter(Boolean);
    if (!filteredRefs.length)
        return null;
    if (filteredRefs.length === 1)
        return filteredRefs[0];
    return (inst) => {
        for (const elementRef of filteredRefs) {
            if (typeof elementRef === 'function') {
                elementRef(inst);
            }
            else if (elementRef) {
                elementRef.current = inst;
            }
        }
    };
};
//# sourceMappingURL=utils.js.map